import { newSpecPage } from '@stencil/core/testing'
import { CobaltToggle } from '../cobalt-toggle'

describe('cobalt-toggle', () => {
  it('should render toggle element unselected', async () => {
    const page = await newSpecPage({
      components: [CobaltToggle],
      html: '<cobalt-toggle label="Label"></cobalt-toggle>'
    })
    expect(page.root).toEqualHtml(`
    <cobalt-toggle label="Label">
      <core-toggle format="right" label="Label"></core-toggle>
    </cobalt-toggle>
    `)
  })
  it('should render toggle element selected', async () => {
    const page = await newSpecPage({
      components: [CobaltToggle],
      html: '<cobalt-toggle label="Label" selected></cobalt-toggle>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-toggle label="Label" selected="">
        <core-toggle format="right" label="Label" selected=""></core-toggle>
      </cobalt-toggle>
    `)
  })
  it('should change format to left', async () => {
    const page = await newSpecPage({
      components: [CobaltToggle],
      html: '<cobalt-toggle label="Label" format="left"></cobalt-toggle>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-toggle format="left" label="Label">
        <core-toggle format="left" label="Label"></core-toggle>
      </cobalt-toggle>
    `)
  })
})
